import script from "./move-back-to-open-confirmation-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./move-back-to-open-confirmation-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__